// src/functions/sortByDate.js

/**
 * Sorts an array of objects by a date key.
 * @param {Array} array
 * @param {string} sortKey
 * @param {boolean} latestFirst  true = newest first
 */
export const sortByDate = (array = [], sortKey = "created_at", latestFirst = true) => {
  array.sort((a, b) => {
    const aTime = a && a[sortKey] ? new Date(a[sortKey]).getTime() : 0;
    const bTime = b && b[sortKey] ? new Date(b[sortKey]).getTime() : 0;
    const diff = bTime - aTime; // positive if b is newer than a
    return latestFirst ? diff : -diff; // newest first or oldest first
  });
  return array;
};
